(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithoutCafDetailController', MultipleUserWithoutCafDetailController);

    MultipleUserWithoutCafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MultipleUserWithoutCaf'];

    function MultipleUserWithoutCafDetailController($scope, $rootScope, $stateParams, previousState, entity, MultipleUserWithoutCaf) {
        var vm = this;

        vm.multipleUserWithoutCaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:multipleUserWithoutCafUpdate', function(event, result) {
            vm.multipleUserWithoutCaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
